import { useMemo } from "react";
import { useClassesEnrollmentsByStudentIdGet } from "@/features/classes/hooks";
import {
  getStudentEnrolledClassSelectOptions,
  normalizeEnrollmentsList,
} from "../utils/student-enrolled-class-options";

interface UseStudentEnrolledClassOptionsProps {
  studentId: number | string | null | undefined;
  enabled?: boolean;
  includeNone?: boolean;
}

export function useStudentEnrolledClassOptions({
  studentId,
  enabled = true,
  includeNone = false,
}: UseStudentEnrolledClassOptionsProps) {
  const numericStudentId =
    studentId != null && studentId !== "" ? Number(studentId) : 0;
  const canFetch = enabled && numericStudentId > 0;

  const { data, isPending, isFetching } = useClassesEnrollmentsByStudentIdGet(
    numericStudentId,
    {
      enabled: canFetch,
      refetchOnMount: true,
    },
  );

  const enrollments = useMemo(() => normalizeEnrollmentsList(data), [data]);

  const classOptions = useMemo(
    () =>
      getStudentEnrolledClassSelectOptions(enrollments, {
        includeNone,
      }),
    [enrollments, includeNone],
  );

  return {
    enrollments,
    classOptions,
    isPending: canFetch && (isPending || isFetching),
  };
}
